<template>
  <div class="page" :class="!smDevice?'pc-width':''">

    <main class="">
      <div class="text-center font-bold">{{ siteName }}</div>
      <div class="flex gap-3 justify-end">
        <PrimaryButton :text="itemSaving?'Saving...':'完了（PDF生成）'" size="sm" class="whitespace-nowrap  w-1/3" :class="itemSaving?'animate-pulse cursor-not-allowed':''" :disabled="itemSaving" @click="generatePdf()" />
        <SecondaryButton :text="itemSaving?'Saving...':'閉じる'" size="sm" class="whitespace-nowrap" :class="itemSaving?'animate-pulse cursor-not-allowed':''" :disabled="itemSaving" @click="closed()" />
      </div>
      <div class="font-bold text-pink-700 text-center mt-5">＊遠めからの写真を正面から1枚・逆側から1枚、アップで1枚（床などの材質が分かるように）撮ってください＊</div>

      <div class="flex gap-6 mt-4">

        <div class="font-bold text-gray-700 cursor-pointer self-center" @click="allOpen()">
          <span class="border-b border-gray-700 px-2">全て開く</span>
        </div>
        <div class="font-bold text-gray-700 cursor-pointer self-center" @click="allClose()">
          <span class="border-b border-gray-700 px-2">全て閉じる</span>
        </div>

        <PrimaryButton :text="itemSaving?'Saving...':'項目編集'" size="sm" class="whitespace-nowrap px-5 bg-teal-600" :class="itemSaving?'animate-pulse cursor-not-allowed':''" :disabled="itemSaving" @click="modalOpen=true" />
      </div>

      <div class="list">
        <div v-for="(row, i) in list" :key="i" class="border shadow-lg border-gray-300 rounded p-2 my-5 bg-gray-100">

          <!-- 開閉ボタン -->
          <div class="font-bold text-light-blue-700 bg-teal-50 cursor-pointer flex gap-2 items-center" @click="clickOpen(row)">
            <span v-if="row.open">▼</span>
            <span v-else>▶</span>
            <div class="whitespace-no-wrap text-lg">{{ row.category }}</div>
          </div>

          <div v-if="row.open" class="mt-10">

            <div v-for="(item) in row.items" :key="item.itemId" class="mt-8">

              <div class="flex justify-between">
                <div class="font-bold text-blue-800">{{ item.item }}</div>

                <!-- 添付ボタン -->
                <div class="file-btn ml-auto w-36" v-tooltip="'このボタンの上にファイルをドロップしても添付できます'">
                  <input class="file-type" type="file" @change="imageToBase64(item, $event)" multiple />
                  <PrimaryButton :text="loading?'Loading...':'添付'" size="sm" class="bg-blue-400 w-full whitespace-nowrap px-5" :class="loading?'animate-pulse cursor-not-allowed':''" :disabled="loading" />
                </div>
              </div>

              <!-- 保存済み写真 -->
              <div v-if="item.photos && item.photos.length" class="photo-list">
                <div v-for="(p, j) in item.photos" :key="item.itemId+'url'+j" class="photo-item">

                  <img :src="p.s3Url" class="object-contain photo">

                  <!-- 削除 -->
                  <div @click="deleteUrl(item, j, p)" class="ml-auto w-fit py-1 px-2 cursor-pointer">
                    <TrashIcon class="text-gray-400 hover:text-gray-500 active:text-gray-600 w-5 h-5" />
                  </div>
                </div>
              </div>

              <!-- 備考 -->
              <textarea
                :placeholder="item.item + ' memo'"
                autocomplete="off"
                :rows="2"
                class="border-gray-300 rounded w-full"
                v-model="item.note"
                @change="saveNote(item)"
              ></textarea>
            </div>
          </div>

        </div>
      </div>
    </main>
    <!-- 項目マスタモーダル -->
    <SiteOutlinePhotoItemMaster
      v-model="modalOpen"
      :siteCode="siteCode"
      :siteName="siteName"
      :open="modalOpen"
      @closed="modalOpen=false"
      @getData="getData"
    />
  </div>
</template>

<script>
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import SiteOutlinePhotoItemMaster from '../components/SiteOutlinePhotoItemMaster.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'
import * as image from '@libs/image'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import PageModel from '../../main/pages/PageModel.vue'

const BASE = [
  // 建物外観
  { category: '建物外観', item: '館銘板', note: '', photos: [], sortNo: 1 },
  { category: '建物外観', item: '建物全景', note: '', photos: [], sortNo: 2 },
  { category: '建物外観', item: 'アプローチ', note: '', photos: [], sortNo: 3 },
  { category: '建物外観', item: '風除室', note: '', photos: [], sortNo: 4 },

  // 共用部（エントランス周辺）
  { category: '共用部（エントランス周辺）', item: 'メールコーナー', note: '', photos: [], sortNo: 5 },
  { category: '共用部（エントランス周辺）', item: 'ポスト', note: '', photos: [], sortNo: 6 },
  { category: '共用部（エントランス周辺）', item: 'エントランス', note: '', photos: [], sortNo: 7 },
  { category: '共用部（エントランス周辺）', item: 'ガラス', note: '', photos: [], sortNo: 8 },
  { category: '共用部（エントランス周辺）', item: '操作盤', note: '', photos: [], sortNo: 9 },
  { category: '共用部（エントランス周辺）', item: 'EV', note: '', photos: [], sortNo: 10 },
  { category: '共用部（エントランス周辺）', item: 'EV操作盤', note: '', photos: [], sortNo: 11 },

  // 管理設備
  { category: '管理設備', item: '管理室', note: '', photos: [], sortNo: 12 },
  { category: '管理設備', item: 'キーケース', note: '', photos: [], sortNo: 13 },
  { category: '管理設備', item: 'トイレ', note: '', photos: [], sortNo: 14 },

  // 共用通路
  { category: '共用通路', item: '廊下', note: '', photos: [], sortNo: 15 },
  { category: '共用通路', item: '腰壁', note: '', photos: [], sortNo: 16 },
  { category: '共用通路', item: '手摺', note: '', photos: [], sortNo: 17 },
  { category: '共用通路', item: '消火器', note: '', photos: [], sortNo: 18 },
  { category: '共用通路', item: 'コンセント', note: '', photos: [], sortNo: 19 },
  { category: '共用通路', item: '自動火災報知機', note: '', photos: [], sortNo: 20 },
  { category: '共用通路', item: '階段', note: '', photos: [], sortNo: 21 },
  { category: '共用通路', item: '階段腰壁', note: '', photos: [], sortNo: 22 },
  { category: '共用通路', item: '階段手摺', note: '', photos: [], sortNo: 23 },

  // ゴミ置き場
  { category: 'ゴミ置き場', item: 'ゴミ置き場', note: '', photos: [], sortNo: 24 },
  { category: 'ゴミ置き場', item: '換気扇', note: '', photos: [], sortNo: 25 },
  { category: 'ゴミ置き場', item: '排水桝', note: '', photos: [], sortNo: 26 },
  { category: 'ゴミ置き場', item: '散水栓', note: '', photos: [], sortNo: 27 },
  { category: 'ゴミ置き場', item: '搬出場所', note: '', photos: [], sortNo: 28 },

  // 建物周辺その他
  { category: '建物周辺その他', item: '監視カメラ', note: '', photos: [], sortNo: 29 },
  { category: '建物周辺その他', item: 'ゲストルーム', note: '', photos: [], sortNo: 30 },
  { category: '建物周辺その他', item: 'バイク駐車スペース', note: '', photos: [], sortNo: 31 },

  // 特別清掃枠
  { category: '特別清掃枠', item: '側溝', note: '', photos: [], sortNo: 32 },
  { category: '特別清掃枠', item: '桝', note: '', photos: [], sortNo: 33 },
  { category: '特別清掃枠', item: '駐輪場', note: '', photos: [], sortNo: 34 },
  { category: '特別清掃枠', item: '駐車場', note: '', photos: [], sortNo: 35 },
  { category: '特別清掃枠', item: '照明器具', note: '', photos: [], sortNo: 36 },
  { category: '特別清掃枠', item: 'ガラリ', note: '', photos: [], sortNo: 37 }
]

export default {
  extends: PageModel,
  components: {
    TrashIcon,
    SecondaryButton,
    PrimaryButton,
    SiteOutlinePhotoItemMaster
  },

  data() {
    return {
      loading: false,
      itemSaving: false,
      reload: 0,
      siteCode: this.$route.query.siteCode,
      // 物件名
      siteName: '',
      // データ
      list: [
        { category: '', open: true, items: [] }
      ],
      // 項目追加モーダル
      modalOpen: false
    }
  },

  created() {
    this.getData()
  },

  computed: {
    userId() {
      return this.$store.getters.user.id
    },

    /**
     * スマホ・タブレット
     */
    smDevice() {
      return utils.deviceInfo.isMobile || utils.deviceInfo.isTablet
    },
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      this.loading = true
      // 基本項目がなければ即保存＆取得
      const res = await backend.postData('siteOutline/photoEdit', { siteCode: this.siteCode, list: BASE, userId: this.userId })
      const list = res.data.data.list
      this.siteName = res.data.data.siteName

      this.setItem(list)

      this.loading = false
    },

    /**
     * データを画面表示の形に成形
     * @param list
     */
    setItem(list) {
      const map = new Map()

      for (const row of list) {
        if (!map.has(row.category)) {
          map.set(row.category, {
            category: row.category,
            open: false,
            items: []
          })
        }

        map.get(row.category).items.push(row)
      }

      this.list = [...map.values()]
    },

    /**
     * 全て開く
     */
    allOpen() {
      this.list.forEach(row => {
        row.open = true
      })
      this.reload++
    },

    /**
     * 全て閉じる
     */
    allClose() {
      this.list.forEach(row => {
        row.open = false
      })
      this.reload++
    },

    /**
     * 開閉
     * @param row 対象カテゴリ
     */
    clickOpen(row) {
      if (row.open) {
        row.open = false
      } else {
        row.open = true
      }
      this.reload++
    },

    /**
     * 写真保存
     * @param row
     * @param event
     */
    async imageToBase64 (row, event) {
      this.loading = true

      if (!row.photos) {
        row.photos = []
      }

      let num = row.photos.length
      try {

        // 選択されたファイルの取得
        const file = event.target.files

        // Base64に変換する
        for (let j = 0; j < file.length; j++) {
          const reader = new FileReader()
          const f = file[j]

          reader.readAsDataURL(f)
          // 変換
          const compressedImage = await new Promise((resolve) => {
            reader.onload = async () => {
              const img = new Image()
              img.src = reader.result

              img.onload = () => {
                const compressedDataUrl = image.compressImage(img, false, 900, 0.8)
                resolve(compressedDataUrl)
              }
            }
          })
          num += j
          const res = await backend.postData('siteOutline/saveDetailphoto', { siteCode: this.siteCode, itemId:row.id, sortNo: num, base64: compressedImage, userId: this.userId })
          let photo = { url: '', s3Url: '' }
          photo = res.data.data
          row.photos.push(photo)
        }

      } catch (error) {
        alert('保存できませんでした。再度添付をお願いいたします。')
      }

        this.loading = false
    },

    /**
     * 写真削除
     * @param item 対象項目
     * @param i 写真のインデックス
     * @param target 対象の写真
     */
    async deleteUrl(item, i, target) {
      try {
        await backend.postData('siteOutline/deleteDetailphoto', { siteCode: this.siteCode, itemId:item.id, url: target.url })
        item.photos.splice(i, 1)
      } catch (error) {
        alert('削除できませんでした。再度お願いいたします。')
      }
    },

    /**
     * 備考保存
     * @param item 対象項目
     */
    async saveNote(item) {
      await backend.postData('siteOutline/saveDetailphotoNote', { siteCode: this.siteCode, item, userId: this.userId })
    },

    /**
     * PDF生成
     */
    async generatePdf() {

      // 備考のみ再保存
      const item = []

      this.list.forEach((row) => {
        row.items.forEach((it) => {
          if (it.note) {
            item.push(it)
          }
        })
      })

      await backend.postData('siteOutline/generatePdf', { siteCode: this.siteCode, siteName: this.siteName, item, userId: this.userId })

      const msg = 'PDF生成完了まで時間がかかることがありますので、物件概要書でPDFの確認は少し時間をおいてください。\nまたPDF生成に失敗しても写真と備考は保存していますので、再度「完了（PDF生成）」を実行すれば大丈夫です。\nこの画面は閉じます。'
      if (this.smDevice) {
        alert(msg)
      } else {
        await dialogs.showInfoDialog('PDF生成中...', msg)
      }

      this.closed()
    },

    /**
     * 閉じる
     */
    closed() {
      window.open('','_self').close()
    },
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  padding: 5px 8px;
  margin: auto;
  font-size: 15px;
  box-sizing: border-box;
}

.pc-width {
  max-width: 900px;
}

.list {
  max-height: calc(100dvh - 170px);
  overflow: auto;
}

.item-form {
  /* min-width: 50%; */
}

.file-btn {
  position: relative;
}

_::-webkit-full-page-media,
_:future,
:root .file-btn {
  position: relative;
}

.file-type {
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

_::-webkit-full-page-media,
_:future,
:root .file-type {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  position: absolute;
}

.photo-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.photo-item {
  width: 100%;
}

.photo {
  width: 100%;
  height: 160px;
  object-fit: contain;
  border: 1px solid #ddd;
  display: block;
}

textarea {
  field-sizing: content;
}
</style>